exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "select.vp-input{-webkit-appearance:none!important;-moz-appearance:none!important;appearance:none!important;background-image:url(" + require("public/images/icons/DropMenuArrow.svg") + ")!important;background-repeat:no-repeat;background-position:calc(100% - 14px);background-color:#fff;border:1px solid #ddd;border-radius:2px}", ""]);

// exports
